import { render, staticRenderFns } from "./Subtop.vue?vue&type=template&id=4a706eaa&scoped=true&"
import script from "./Subtop.vue?vue&type=script&lang=js&"
export * from "./Subtop.vue?vue&type=script&lang=js&"
import style0 from "./Subtop.vue?vue&type=style&index=0&id=4a706eaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a706eaa",
  null
  
)

export default component.exports